<template>
<div>
  <v-layout>
    <v-flex xs1 offset-xs10>
      <UploadFile />
    </v-flex>
    <v-flex xs1>
      <MultiFormUpload />
    </v-flex>
  </v-layout>
  <v-card>
    <v-card-title class="title">
      {{ $t("dashboard.completed-forms-chart-title") }}
    </v-card-title>
    <v-progress-circular v-if="chartLoading" :size="70" :rotate="30" :width="5" class="loading-circle" indeterminate></v-progress-circular>
    <apex-chart v-else type="bar" height="400" :options="options" :series="series"></apex-chart>
  </v-card>
  <v-divider />
</div>
</template>

<script>
import http from '@/plugins/http'
import apexcharts from 'vue-apexcharts'
import UploadFile from './UploadFile'
import MultiFormUpload from './MultiFormUpload'

export default {
  components: {
    'apex-chart': apexcharts,
    UploadFile,
    MultiFormUpload
  },
  computed: {
    options() {
      return {
        chart: {
          id: 'increase-of-completed-forms',
          toolbar: {
            show: false
          }
        },
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
        xaxis: {
          categories: this.chartData.map(value => value.date)
        }
      }
    },
    series() {
      return [{
        name: this.$t("dashboard.completed-forms"),
        data: this.chartData.map(value => value.amount)
      }]
    }
  },
  data() {
    return {
      chartLoading: false,
      chartData: []
    }
  },
  created() {
    this.chartLoading = true
    http.get('statistics/filled-forms')
      .then(({
        data
      }) => {
        this.chartData = data
        this.chartLoading = false
      }).catch(() => {
        this.chartLoading = false
      })
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}
</style>
